<template>
<div>
  <v-card>
    <v-card-title>Members</v-card-title>
    <v-card-text>
      <v-list >
        <template v-for="member in group.MsgGroupMembers" >
          <v-list-item :key='member.msg_group_member_id'>
            <v-list-item-avatar>
              <v-icon v-if="member.reference_entity_type=='user'">mdi-account</v-icon>
              <span v-if="member.reference_entity_type=='smsnumber'"><i>SMS</i></span>
            </v-list-item-avatar>

            <v-list-item-content>            
                  {{member.name}}
            </v-list-item-content>

            <v-list-item-action>
              <v-btn text color="blue" v-on:click="removeMsgGroupMember(member)">
                Remove
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      <br>
      <v-tabs
      background-color="white"
      v-if="notTwoPersonGroup"
    >
      <v-tab>
        Add User
      </v-tab>
           
        <v-tab-item>
          <v-card flat>
            <div class="form-group has-success" style="padding: 12px 12px 12px 12px">
                <label class="control-label" for="fnameTxt">Email</label>
                <input id="emailTxt" type="text" v-model="email" class="form-control" />
                <span class="help-block">{{emailErrorTxt}}</span>
            </div>

            <div class="form-group" style="padding: 12px 12px 12px 12px">
              <button class="btn btn-primary" @click="addEmailContact()">Add</button>
              &nbsp;
            </div>
          </v-card>
        </v-tab-item>

    </v-tabs>
    </v-card-text>
  </v-card>  
</div>
</template>

<script >

let addUserToMsgGroupTxt = `
    mutation addUserToMsgGroup($input: AddEmailContactInput) {
      addUserToMsgGroup(input: $input) {
        msg_group_member_id
        msg_group_id
        reference_entity_id
        reference_entity_type
        name
      }
    }
  `;

let removeMsgGroupMemberTxt = `
    mutation removeMsgGroupMember($input: MsgGroupMemberInput) {
      removeMsgGroupMember(input: $input)
    }
  `;
 
export default {

  props: [
    'group'
  ],
  computed: {
    notTwoPersonGroup: function() {
      if (this.group.user_id_1 && this.group.user_id_2) {
        return false;
      } else {
        return true;
      }
    },
  },
  data () {
    return {
      isEmail: true,
      tab: null,
      name: '',
      email: '',
      number: '',
      fromNumber: '',
      emailErrorTxt: '',
    }
  },
  methods: {
    addEmailContact: function() {
      if (addEmail !== null) {
        let self = this;      
        let variables = {
          input: {
              name: this.name,
              email: this.email,
              msg_group_id: this.group.msg_group_id,
          }
        };
        const gqlClient = global.gqlClient();
        gqlClient.request(addUserToMsgGroupTxt, variables).then(function(result) {
          let msgGroupMember = result.addUserToMsgGroup;
          if (msgGroupMember) {
            self.group.MsgGroupMembers.push(msgGroupMember);
            self.email = '';
          } else {
            self.emailErrorTxt = m.errorMessage;
          }
        });
      } 
    },
    removeMsgGroupMember: function(msgGroupMember) {
      let self = this;      
      let variables = {
        input: {
            msg_group_member_id: msgGroupMember.msg_group_member_id,
            msg_group_id: msgGroupMember.msg_group_id,
        }
      };
      const gqlClient = global.gqlClient();
      gqlClient.request(removeMsgGroupMemberTxt, variables).then(function(result) {
        console.log(result);
        if (result.removeMsgGroupMember == true) {
          // get index of object with the msg_group_member_id
          let removeIndex = self.group.MsgGroupMembers.map(function(item) { return item.msg_group_member_id; }).indexOf(msgGroupMember.msg_group_member_id);
          // remove object
          self.group.MsgGroupMembers.splice(removeIndex, 1);
        }
      })
    },
  },
  watch: {

  },
  mounted() {
    console.log('showing members');
    console.log(this.group);
  }
}
</script>


<style lang='scss' scoped>
</style>
